import React from "react";
import { connect } from "react-redux";
import {
    Button,
    ButtonGroup,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    InputGroup,
    Row,
} from "react-bootstrap";
import axios from "axios";
import parse from "html-react-parser";

import locale from "../../../locale";
import Loading from "../../Loading";
import Tooltip from "../../UI/Tooltip";
import Breadcrumbs from "../../UI/Breadcrumbs";
import FormControlLanguage from "../../UI/FormControlLanguage";
import ReactSelect from "react-select";

const activeCrumbs = ["mainMenu.emails", "mainMenu.emails.globalSettings"];
const themeColors = [
    {
        title: locale("email.accentColor"),
        key: "accentColor",
        defaultValue: "#FF434C",
    },
];

class EmailSettingsGlobal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            isSaving: false,
            smtpServer: "",
            senderAddress: "",
            senderDomain: "",
            senderName: "",
            settings: null,
            posterFile: null,
            theme: "dark",
            vkLink: "",
            telegramLink: "",
            odnoklassnikiLink: "",
            youtubeLink: "",
            dzenLink: "",
            accentColor: "#FF434C",
            darkColor: "#16161B",
            lightColor: "#FFFFFF",
            disclaimerRu: "",
            disclaimerEn: "",
            clientServersList: [],
        };

        this.posterUploadRef = null;
    }

    componentDidMount() {
        const { event } = this.props;

        this.setState({ isLoading: true });

        axios
            .get(`/api/cp/event/${event.eventPassword}/emailSettings`)
            .then((response) => response.data)
            .then((settings) => {
                const [name, domain] = settings.senderAddress?.split('@');

                this.setState({
                    isLoading: false,
                    settings,
                    smtpServer: settings.smtpSettings?.id || "",
                    senderAddress: name || "",
                    senderDomain: domain || "comdi.com",
                    senderName: settings.senderName || "",
                    posterUrl: settings.posterUrl,
                    theme: settings.theme || "dark",
                    vkLink: settings.vkLink || "",
                    telegramLink: settings.telegramLink || "",
                    odnoklassnikiLink: settings.odnoklassnikiLink || "",
                    youtubeLink: settings.youtubeLink || "",
                    dzenLink: settings.dzenLink || "",
                    accentColor: settings.accentColor || "#FF434C",
                    darkColor: settings.darkColor || "#16161B",
                    lightColor: settings.lightColor || "#FFFFFF",
                    disclaimerRu: settings.disclaimerRu || "",
                    disclaimerEn: settings.disclaimerEn || "",
                });
            });

        this.fetchSmtpServers(event.eventKey);
    }

    fetchSmtpServers(eventKey) {
        axios
            .get(`/api/cp/event/${eventKey}/smtp`)
            .then(({ data }) => {
                this.setState({ clientServersList: data });
            })
            .catch((error) => {
                if (error.response?.data?.message) {
                    alert(error.response.data.message);
                }
            });
    }

    saveProperty(name, value) {
        if (this.state.settings[name] === value) {
            return;
        }

        const form = new FormData();
        form.append(name, value);
        this.saveSettings(form);
    }

    changeProperty(name, value) {
        if (name === "senderAddress") {
            value = value.replace(/[^-.\w]/, "");
        }

        if (name === "theme") {
            const form = new FormData();
            form.append(name, value);
            form.append("darkColor", value === "dark" ? "#16161B" : "#domain#16161B");
            this.saveSettings(form);
        }

        this.setState({ [name]: value });
    }

    saveSettings(form) {
        this.setState({ isSaving: true });
        const { event } = this.props;

        axios
            .post(`/api/cp/event/${event.eventPassword}/emailSettings`, form)
            .then(({ data }) => {
                const settings = Object.assign({}, this.state.settings, data);
                this.setState({ settings, isSaving: false });
            })
            .catch((error) => {
                if (error.response?.data?.message) {
                    alert(error.response.data.message);
                }
            });
    }

    saveSmtpServer(smtp) {
        const { event } = this.props;

        axios
            .post(`/api/cp/event/${event.eventKey}/smtp`, {smtpId: smtp})
            .catch((error) => {
                if (error.response?.data?.message) {
                    alert(error.response.data.message);
                }
            });

        if (!smtp) {
            const data = {senderName: "", senderAddress: ""};
            this.saveSettings(data);
            this.setState(data);

            return;
        }

        const server = this.state.clientServersList.find(({id}) => id === smtp);
        const [name, domain] = server?.senderEmail.split('@');
        const data = {
            senderName: server?.senderName,
            senderAddress: name,
        }

        this.setState({...data, senderDomain: domain});
        this.saveSettings({senderName: server?.senderName, senderAddress: server?.senderEmail});
    }

    handlePosterSelectClick() {
        this.posterUploadRef.click();
    }

    handlePosterSelect(e) {
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        this.saveProperty("posterFile", file);
    }

    handlePosterDelete() {
        this.saveProperty("posterFile", "DELETE");
    }

    sanitizeSenderAddress(text) {
        text = text.replace(/[^a-z0-9_.\-]/, "");
        text = text.replace(/^[._\-]+/, "");
        text = text.replace(/[._\-]+$/, "");

        return text;
    }

    render() {
        const { event } = this.props;
        const { isLoading, clientServersList, disclaimerRu, disclaimerEn } = this.state;
        const serversList = [{id: null, name: 'COMDI (по умолчанию)'}].concat(clientServersList);

        const saveDisclaimer = () => {
            const form = new FormData();
            form.append("disclaimerRu", disclaimerRu);
            form.append("disclaimerEn", disclaimerEn);

            this.saveSettings(form);
        }

        if (isLoading) {
            return <Loading />;
        }

        return (
            <section>
                <Breadcrumbs
                    link={`/event/${event.eventPassword}`}
                    activeCrumbs={activeCrumbs}
                />

                <Form>
                    <FormGroup>
                        <Row>
                            <Col xs={5}>
                                <FormGroup style={{position: 'relative', zIndex: 3}}>
                                    <ControlLabel>
                                        {locale("email.smtpServerSettings")}
                                    </ControlLabel>
                                    <ReactSelect
                                        defaultValue={this.state.smtpServer}
                                        name="smtpServer"
                                        options={serversList.map(({id, name}) => ({
                                            value: id,
                                            label: name,
                                        }))}
                                        placeholder={
                                            this.state.smtpServer
                                                ? serversList.find(({id}) => this.state.smtpServer === id)?.name
                                                : "COMDI (по умолчанию)"
                                        }
                                        onChange={({value}) => this.saveSmtpServer(value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={5}>
                                <ControlLabel>
                                    {locale("email.senderAddress")}
                                    <Tooltip>
                                        {locale("email.globalEmailTooltip")}
                                    </Tooltip>
                                </ControlLabel>
                                <FormGroup>
                                    <InputGroup>
                                        <FormControl
                                            type="text"
                                            value={this.state.senderAddress}
                                            onChange={(e) =>
                                                this.changeProperty(
                                                    "senderAddress",
                                                    this.sanitizeSenderAddress(
                                                        e.target.value
                                                    )
                                                )
                                            }
                                            onBlur={(e) =>
                                                this.saveProperty(
                                                    "senderAddress",
                                                    this.sanitizeSenderAddress(
                                                        e.target.value
                                                    )
                                                )
                                            }
                                            placeholder={"service"}
                                        />
                                        <InputGroup.Addon>
                                            @{this.state.senderDomain}
                                        </InputGroup.Addon>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col xs={5}>
                                <ControlLabel>
                                    {locale("email.senderName")}
                                    <Tooltip>
                                        {locale("email.globalEmailTooltip")}
                                    </Tooltip>
                                </ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.senderName}
                                    onChange={(e) =>
                                        this.changeProperty(
                                            "senderName",
                                            e.target.value
                                        )
                                    }
                                    onBlur={(e) =>
                                        this.saveProperty(
                                            "senderName",
                                            e.target.value
                                        )
                                    }
                                    placeholder={"COMDI"}
                                />
                            </Col>
                        </Row>
                        {this.state.settings.isAllowLoginWithToken && (
                            <>
                                <Row>
                                    <Col xs={5}>
                                        <ControlLabel>
                                            {locale("email.platformLink")}
                                        </ControlLabel>
                                        <Row>
                                            <Col xs={4}>
                                                {locale("email.containsToken")}
                                            </Col>
                                            <Col>
                                                {locale("email.yes")}
                                                <Tooltip width="550px">
                                                    {parse(locale("email.hasTokenTooltip"))}
                                                </Tooltip>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "15px" }}>
                                    <Col xs={5}>
                                        <ControlLabel>
                                            {locale("email.disclaimerTitle")}
                                            <Tooltip width="400px">
                                                {locale("email.disclaimerTooltip")}
                                            </Tooltip>
                                        </ControlLabel>
                                        <FormControlLanguage
                                            componentClass="textarea"
                                            rows={4}
                                            values={{
                                                ru: this.state.disclaimerRu,
                                                en: this.state.disclaimerEn,
                                            }}
                                            onChange={{
                                                ru: (e) => this.changeProperty("disclaimerRu", e.target.value),
                                                en: (e) => this.changeProperty("disclaimerEn", e.target.value),
                                            }}
                                            onBlur={saveDisclaimer}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Row style={{ marginTop: "15px" }}>
                            <Col xs={5}>
                                <ControlLabel>
                                    {locale("email.colorScheme")}
                                    <Tooltip>
                                        {locale("email.globalEmailTooltip")}
                                    </Tooltip>
                                </ControlLabel>
                                {themeColors.map(({ title, key }) => (
                                    <FormGroup
                                        key={key}
                                        style={{
                                            display: "flex",
                                            gap: "8px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <input
                                            type="color"
                                            value={this.state[key]}
                                            onChange={(e) =>
                                                this.changeProperty(
                                                    key,
                                                    e.target.value
                                                )
                                            }
                                            onBlur={(e) =>
                                                this.saveProperty(
                                                    key,
                                                    e.target.value
                                                )
                                            }
                                        />
                                        <span>{title}</span>
                                    </FormGroup>
                                ))}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={5}>
                                <ControlLabel>
                                    {locale("email.poster")}
                                    <Tooltip width="400px">
                                        {locale("email.settingsPosterTooltip")}
                                    </Tooltip>
                                </ControlLabel>
                                {this.state.settings?.posterUrl && (
                                    <FormGroup>
                                        <img
                                            src={this.state.settings?.posterUrl}
                                            alt={locale("email.poster")}
                                            style={{maxWidth: "400px"}}
                                        />
                                    </FormGroup>
                                )}
                                <div>
                                    <FormControl
                                        type="file"
                                        inputRef={(ref) => (this.posterUploadRef = ref)}
                                        style={{ display: "none" }}
                                        onChange={(e) => this.handlePosterSelect(e)}
                                    />
                                    <ButtonGroup>
                                        <Button onClick={() => this.handlePosterSelectClick()}>
                                            {locale("email.upload")}
                                        </Button>
                                        {this.state.settings?.posterUrl && (
                                            <Button onClick={() => this.handlePosterDelete()}>
                                                {locale("email.delete")}
                                            </Button>
                                        )}
                                        {this.state.settings?.posterUrl && (
                                            <Button
                                                href={this.state.settings.posterUrl}
                                                target="_blank"
                                            >
                                                {locale("email.open")}
                                            </Button>
                                        )}
                                    </ButtonGroup>
                                </div>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "15px" }}>
                            <Col xs={5}>
                                <ControlLabel>
                                    {locale("email.socialNetworks")}
                                    <Tooltip width="300px">
                                        {locale("email.footerTemplateTooltip")}
                                    </Tooltip>
                                </ControlLabel>
                                <FormGroup>
                                    <InputGroup>
                                        <InputGroup.Addon>
                                            {locale("email.vk")}
                                        </InputGroup.Addon>
                                        <FormControl
                                            type="text"
                                            value={this.state.vkLink}
                                            onChange={(e) =>
                                                this.changeProperty(
                                                    "vkLink",
                                                    e.target.value
                                                )
                                            }
                                            onBlur={(e) =>
                                                this.saveProperty(
                                                    "vkLink",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup>
                                        <InputGroup.Addon>
                                            {locale("email.classmates")}
                                        </InputGroup.Addon>
                                        <FormControl
                                            type="text"
                                            value={this.state.odnoklassnikiLink}
                                            onChange={(e) =>
                                                this.changeProperty(
                                                    "odnoklassnikiLink",
                                                    e.target.value
                                                )
                                            }
                                            onBlur={(e) =>
                                                this.saveProperty(
                                                    "odnoklassnikiLink",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup>
                                        <InputGroup.Addon>
                                            {locale("email.telegram")}
                                        </InputGroup.Addon>
                                        <FormControl
                                            type="text"
                                            value={this.state.telegramLink}
                                            onChange={(e) =>
                                                this.changeProperty(
                                                    "telegramLink",
                                                    e.target.value
                                                )
                                            }
                                            onBlur={(e) =>
                                                this.saveProperty(
                                                    "telegramLink",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup>
                                        <InputGroup.Addon>
                                            YouTube
                                        </InputGroup.Addon>
                                        <FormControl
                                            type="text"
                                            value={this.state.youtubeLink}
                                            onChange={(e) =>
                                                this.changeProperty(
                                                    "youtubeLink",
                                                    e.target.value
                                                )
                                            }
                                            onBlur={(e) =>
                                                this.saveProperty(
                                                    "youtubeLink",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup>
                                        <InputGroup.Addon>
                                            {locale("email.dzen")}
                                        </InputGroup.Addon>
                                        <FormControl
                                            type="text"
                                            value={this.state.dzenLink}
                                            onChange={(e) =>
                                                this.changeProperty(
                                                    "dzenLink",
                                                    e.target.value
                                                )
                                            }
                                            onBlur={(e) =>
                                                this.saveProperty(
                                                    "dzenLink",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
            </section>
        );
    }
}

const mapStateToProps = (store) => ({
    event: store.currentEvent,
});

export default connect(mapStateToProps)(EmailSettingsGlobal);
